export default {
  form: {
    font_family: {
      label: 'Lettertype',
    },
    header: {
      label: 'Koptekst',
      placeholder: 'Koptekst',
    },
    sub_header: {
      label: 'Subkoptekst',
      placeholder: 'Subkoptekst',
    },
    footer: {
      label: 'Voettekst',
      placeholder: 'Voettekst invoeren',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL selecteren',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primaire kleur',
    },
    background_color: {
      label: 'Achtergrondkleur',
    },
    cover_image: {
      label: 'Omslagafbeelding',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Logo zoom',
    },
  },
  toasts: {
    failed_to_load_data: 'Deursticker laden mislukt',
  },
};
